import { MenuItem } from '../models/menu/menu.model';

export const mfrsMenu: MenuItem[] = [];
